export default {
  acceptTermsRequired: 'অনুগ্রহ করে terms and conditions গ্রহণ করুন',
  accountNumber: 'A/C Number',
  acknowledgedText: 'স্বীকৃত',
  acknowledgeText: 'স্বীকার করুন',
  active: 'সক্রিয়',
  activeBookings: 'সক্রিয় বুকিং',
  activeBucketsText: 'সক্রিয় বাকেট',
  activeToday: 'আজ সক্রিয়',
  adminRole: 'অ্যাডমিন — ব্যবস্থাপনা পরিচালক',
  advance: 'অগ্রিম',
  advancePaid: 'অগ্রিম প্রদত্ত',
  advancePaidLabel: 'অগ্রিম',
  agreement: 'শর্তাবলী ও চুক্তি',
  agreeTermsCheckbox: 'আমি সমস্ত শর্তাবলী ও শর্ত পড়েছি এবং সম্মত',
  alertLog: 'সতর্কতা লগ',
  alerts: 'সতর্কতা',
  alertText: 'সতর্কতা',
  allAlerts: 'সমস্ত সতর্কতা',
  allLoaded: 'সব লোড',
  allMachinesOk: 'সমস্ত মেশিন ঠিকমতো চলছে।',
  allowedText: 'অনুমোদিত',
  allStats: 'সম্পূর্ণ পরিসংখ্যান',
  amount: 'পরিমাণ',
  apiHealthTitle: 'API Health',
  apiSloAlertsTitle: 'API SLO Alerts',
  appName: 'ডেভেলপমেন্ট এক্সপ্রেস',
  approvals: 'অনুমোদন',
  approveAndDispatch: 'অনুমোদন করে মেশিন পাঠান',
  approved: 'অনুমোদিত',
  assignedOperator: 'নিয়োজিত অপারেটর',
  attemptsLabel: 'চেষ্টা',
  attendance: 'উপস্থিতি',
  auditLogs: 'অডিট লগ',
  available: 'উপলব্ধ',
  availableMachinery: 'উপলব্ধ মেশিনারি',
  availableNow: 'এখন উপলব্ধ',
  avgRating: 'গড় রেটিং',
  awaitingClientFeedback: 'গ্রাহক প্রতিক্রিয়ার জন্য অপেক্ষা',
  awaitingDispatch: 'ডিসপ্যাচের জন্য অপেক্ষা',
  back: 'পিছনে',
  backToLogin: 'লগইনে ফিরে যান',
  bank: 'ব্যাংক',
  bankDetailsTitle: 'ব্যাংক বিবরণ',
  baseAmount: 'মূল পরিমাণ',
  billingWallet: 'ওয়ালেট ও বিলিং',
  blacklistWarning: '⛔ ব্ল্যাকলিস্ট সতর্কতা',
  blockedRateText: 'ব্লক রেট',
  blockedText: 'ব্লক করা',
  bookingConfirm: 'বুকিং নিশ্চিত করুন',
  bookingCostCalculator: 'বুকিং ও খরচ ক্যালকুলেটর',
  bookingFailedGeneric: 'বুকিং ব্যর্থ। আবার চেষ্টা করুন।',
  bookingHistory: 'বুকিং ইতিহাস',
  bookingReportTitle: 'বুকিং রিপোর্ট',
  bookingScheduleSummary: 'দৈনিক ও মাসিক বুকিং সময়সূচি',
  bookingsCount: '{count} বুকিং',
  bookingSelectMachineFirst: 'চালিয়ে যেতে ফ্লিট থেকে মেশিন নির্বাচন করুন।',
  bookingsScheduleHint: 'গ্রাহকরা বুক করলে দৈনিক সময়সূচি এখানে দেখা যাবে।',
  bookingStepChoose: 'মেশিন নির্বাচন',
  bookingStepConfirm: 'নিশ্চিত করে পেমেন্ট',
  bookingStepCost: 'খরচ ও তারিখ',
  bookingType: 'বুকিং ধরন নির্বাচন',
  bookingTypeLabel: 'বুকিং ধরন',
  bookingTypeText: 'বুকিং ধরন',
  bookMachine: 'মেশিন বুক করুন',
  bookMachineAction: 'মেশিন বুক করুন',
  bookNow: 'এখনই বুক করুন',
  burstText: 'BURST',
  busy: 'ব্যস্ত',
  callNow: 'এখনই কল করুন',
  cancel: 'বাতিল',
  cancelAction: 'বাতিল করুন',
  cancelBooking: 'বুকিং বাতিল',
  cancelBookingPrompt: 'বুকিং বাতিল করবেন?',
  cancelPolicy: 'বাতিল নীতি',
  cancelText: 'বাতিল',
  cancelWarning: 'আপনি কি বাতিল করতে চান?',
  changeLanguage: 'ভাষা পরিবর্তন করুন',
  changeMachine: 'মেশিন পরিবর্তন',
  changeMobileNumber: 'মোবাইল নম্বর পরিবর্তন',
  chipAction: 'কর্ম',
  chipActor: 'অভিনেতা',
  chipEntity: 'entity',
  chipFrom: 'থেকে',
  chipMeta: 'meta',
  chipRole: 'ভূমিকা',
  chipTo: 'পর্যন্ত',
  clearAll: 'সব মুছুন',
  client: 'গ্রাহক',
  clientFeedbackLabel: 'গ্রাহক প্রতিক্রিয়া',
  clientPortal: 'গ্রাহক পোর্টাল',
  clientRatingsTitle: 'গ্রাহক রেটিং ও পরামর্শ',
  clientRole: 'গ্রাহক (ঠিকাদার)',
  clients: 'গ্রাহক',
  commission: 'কমিশন',
  commission15: 'কমিশন ১৫%',
  commissionPaid: 'কমিশন প্রদত্ত',
  commissionRate: 'মোট বিলিংয়ের ১৫%',
  company: 'কোম্পানি',
  companyDetailsTitle: 'কোম্পানির বিবরণ',
  completeBookings: 'সম্পন্ন বুকিং',
  completedBookings: 'সম্পন্ন বুকিং',
  condition: 'অবস্থা',
  confirm: 'নিশ্চিত করুন',
  confirmBooking: 'বুকিং নিশ্চিত করুন',
  confirmBookingAction: 'বুকিং নিশ্চিত করুন',
  confirmCancel: 'বাতিল নিশ্চিত করুন',
  confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
  confirmRetry: 'পুনরায় চেষ্টা নিশ্চিত করুন',
  contactCompany: 'Development Express-এ যোগাযোগ করুন',
  costCalculator: 'খরচ ক্যালকুলেটর',
  crawlerNoRto: 'Crawler (RTO নেই)',
  currentlyDeployed: 'বর্তমানে মোতায়েন',
  customAmount: 'কাস্টম পরিমাণ (ন্যূনতম ₹৫,০০০)',
  cycles: "চক্র",
  dailyWorkReport: 'দৈনিক কাজের রিপোর্ট',
  dashboard: 'ড্যাশবোর্ড',
  date: 'তারিখ',
  dayMachinesLabel: 'মেশিন',
  days: 'দিন',
  daysUnit: 'দিন',
  directContactBlacklist: 'সরাসরি যোগাযোগ = ব্ল্যাকলিস্ট',
  directContactProhibited: 'সরাসরি যোগাযোগ কঠোরভাবে নিষিদ্ধ',
  directContactProhibitedText: 'সরাসরি যোগাযোগ কঠোরভাবে নিষিদ্ধ',
  dispatched: 'প্রেরিত',
  dlqMonitor: 'DLQ মনিটর',
  docChassisPlate: 'Chassis / Serial Plate Photo (RTO RC নেই)',
  docEquipmentPhoto: 'Full Machine Photo (side view)',
  docIdentity: 'PAN Card / Aadhaar',
  docInsurance: 'Insurance Certificate',
  docInsuranceOptional: 'Insurance / Equipment Cover (if available)',
  docMachineInvoice: 'Machine Purchase / Invoice (dealer bill)',
  docPollution: 'Pollution Certificate (PUC)',
  docRcBook: 'RC Book (RTO Registration Certificate)',
  documents: 'নথি আপলোড',
  documentUploadTitle: 'নথি আপলোড',
  download: 'ডাউনলোড',
  drawerMenu: 'মেনু',
  earnings: 'আয়',
  email: 'ইমেইল সহায়তা',
  emailAddress: 'ইমেইল ঠিকানা',
  emailAddressLabel: 'ইমেইল ঠিকানা',
  expandBookingHint: 'সম্পূর্ণ বুকিং, বাতিল ও অপারেটর রেটিংয়ের জন্য নিচে মাস/দিন বিভাগ প্রসারিত করুন।',
  experience: 'অভিজ্ঞতা',
  exportCsv: 'CSV এক্সপোর্ট',
  failedText: 'ব্যর্থ',
  feedbackAfterDispatch: 'মেশিন ডিসপ্যাচের পর অপারেটর রেটিং উপলব্ধ হবে।',
  feedbackStatusAfterDispatch: 'ডিসপ্যাচের পর',
  feedbackStatusRateNow: 'অপারেটর রেট করুন ↓',
  filterAll: 'সব',
  filterCredit: 'ক্রেডিট',
  filterDebit: 'ডেবিট',
  filterCompleted: 'সম্পন্ন',
  filterCancelled: 'বন্ধ',
  filterPending: 'অপেক্ষমাণ',
  filterDisputed: 'বিরোধ',
  forgotPasswordChooseMethod: 'পাসওয়ার্ড রিসেটের জন্য ইমেইল লিংক বা SMS OTP বেছে নিন।',
  forgotPasswordEmailDevHint: 'Local dev: API server টার্মিনাল খুলে “Password reset link (development)” URL কপি করুন।',
  forgotPasswordEmailHint: 'নিবন্ধিত অ্যাডমিন ইমেইল ঠিকানা লিখুন।',
  forgotPasswordFailed: 'রিসেট লিংক পাঠাতে ব্যর্থ। আবার চেষ্টা করুন।',
  forgotPasswordIntro: 'নিবন্ধিত ইমেইল ঠিকানায় নিরাপদ রিসেট লিংক পাঠাব।',
  forgotPasswordInvalidEmail: 'বৈধ ইমেইল ঠিকানা লিখুন।',
  forgotPasswordInvalidOtp: 'SMS থেকে ৬ সংখ্যার OTP লিখুন।',
  forgotPasswordInvalidPhone: 'বৈধ ১০ সংখ্যার মোবাইল নম্বর লিখুন।',
  forgotPasswordLink: 'পাসওয়ার্ড ভুলে গেছেন?',
  forgotPasswordOtpSentTo: 'OTP পাঠানো হয়েছে:',
  forgotPasswordPhoneHint: 'নিবন্ধিত মোবাইল নম্বর লিখুন। রিসেট লিংক আপনার অ্যাকাউন্টের ইমেইলে যাবে।',
  forgotPasswordSending: 'পাঠানো হচ্ছে...',
  forgotPasswordSendingOtp: 'OTP পাঠানো হচ্ছে...',
  forgotPasswordSendOtp: 'OTP পাঠান',
  forgotPasswordSmsDevHint: 'Production-এ SMS এখনো সেট নয় — development-এ OTP কোডের জন্য server logs দেখুন।',
  forgotPasswordSmsFailed: 'OTP পাঠাতে ব্যর্থ। আবার চেষ্টা করুন।',
  forgotPasswordSmsHint: 'নিবন্ধিত মোবাইল নম্বর লিখুন। ৬ সংখ্যার OTP SMS-এ পাঠানো হবে।',
  forgotPasswordSmsSuccess: 'অ্যাকাউন্ট থাকলে, নিবন্ধিত মোবাইলে OTP পাঠানো হয়েছে।',
  forgotPasswordSubmit: 'রিসেট লিংক পাঠান',
  forgotPasswordSuccess: 'অ্যাকাউন্ট থাকলে, নিবন্ধিত ইমেইলে রিসেট নির্দেশনা পাঠানো হয়েছে।',
  forgotPasswordTitle: 'আপনার পাসওয়ার্ড রিসেট করুন',
  formLabel: 'ফর্ম',
  fuel: 'জ্বালানি',
  fuelColon: 'জ্বালানি:',
  fuelHistoryTitle: 'জ্বালানি ইতিহাস',
  fuelLevel: 'জ্বালানি স্তর',
  fuelLevelUpdate: 'জ্বালানি স্তর আপডেট',
  fuelNotePlaceholder: 'নোট: ভরাট / ব্যবহৃত জ্বালানি...',
  fullName: 'পূর্ণ নাম',
  goBook: '→ মেশিন বুক করুন',
  gpsLiveLabel: '🟢 GPS লাইভ',
  grandTotal: 'সর্বমোট',
  grandTotalText: 'সর্বমোট',
  gross: 'মোট',
  grossBilling: 'মোট বিলিং',
  gst18: 'GST (18%)',
  gstin: 'GSTIN',
  gstInvoice: 'GST ইনভয়েস',
  gstInvoices: 'GST ইনভয়েস',
  hide: 'লুকান',
  highTrend: 'HIGH Trend',
  hitsText: 'hits',
  hmrHrs: 'ঘণ্টা',
  hmrToday: 'আজকের HMR',
  hmrTotal: 'মোট HMR',
  home: 'হোম',
  hours: 'ঘণ্টা',
  hrsUnit: 'ঘণ্টা',
  idle: 'নিষ্ক্রিয়',
  ifsc: 'IFSC',
  ignition: 'ইগনিশন',
  importantInfo: 'মেশিন মালিকদের জন্য গুরুত্বপূর্ণ তথ্য',
  instantCost: 'তাৎক্ষণিক খরচ ক্যালকুলেটর',
  invoiceNotAvailableCancelled: 'ইনভয়েস উপলব্ধ নয় (বাতিল)',
  iot: 'IoT & GPS',
  issueReportedSuccess: 'সমস্যা সফলভাবে রিপোর্ট হয়েছে!',
  issueReportTitle: 'সমস্যা রিপোর্ট',
  issues: 'সমস্যা',
  joinUsAction: 'Join Us — বিনামূল্যে নিবন্ধন',
  joinUsBanner: 'মেশিনারি ভাড়া চান?',
  joinUsHint: 'নতুন গ্রাহক? JCB, excavator, crane বুক করতে বিনামূল্যে নিবন্ধন করুন।',
  landingCtaApp: 'Development Express অন্বেষণ করুন',
  landingFeatBook: 'মিনিটে বুকিং',
  landingFeatBookDesc: 'JCB, excavators, cranes — live availability & instant booking.',
  landingFeatPay: 'Wallet-only payments',
  landingFeatPayDesc: 'স্বচ্ছ বিলিং, GST invoices, নগদ ঝামেলা নেই।',
  landingFeatTrack: 'Live GPS tracking',
  landingFeatTrackDesc: 'ভাড়ার প্রতিটি ঘণ্টায় আপনার মেশিন কোথায় জানুন।',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'মহারাষ্ট্র মেশিনারি ভাড়া — নতুন রীতি।',
  landingSocialProof: 'মহারাষ্ট্র জুড়ে নির্মাতা, ঠিকাদার ও ফ্লিট মালিক।',
  landingStatMachines: 'মেশিন',
  landingStatRating: 'রেটিং',
  landingTrustLine: 'Wallet-only · GST compliant · Secured operations',
  lastRefreshed: 'শেষ রিফ্রেশ',
  live: 'লাইভ',
  liveBookAvail: 'বুকিংয়ের পর লাইভ ফিড উপলব্ধ',
  liveCamera: '৩৬০° লাইভ ক্যামেরা — বুকিংয়ের পর',
  liveMachineLocation: 'লাইভ মেশিন অবস্থান',
  liveText: 'লাইভ',
  liveTracking: 'লাইভ ট্র্যাকিং',
  loadedBookings: 'লোড করা বুকিং',
  loadedDlqItems: 'লোড করা DLQ আইটেম',
  loadedFuelLogs: 'লোড করা জ্বালানি লগ',
  loadedOwnerBookings: '{count} মালিক বুকিং লোড{suffix}',
  loading: 'লোড হচ্ছে...',
  loadingDashboard: 'ড্যাশবোর্ড লোড হচ্ছে...',
  loadMoreAlerts: 'আরও সতর্কতা লোড করুন',
  loadMoreAttendance: 'আরও উপস্থিতি লোড করুন',
  loadMoreBookings: 'আরও বুকিং লোড করুন',
  loadMoreDlq: 'আরও DLQ লোড করুন',
  loadMoreFuelLogs: 'আরও জ্বালানি লগ লোড করুন',
  loadMoreLogs: 'আরও লগ লোড করুন',
  loadMoreMachines: 'আরও মেশিন লোড করুন',
  loadMoreTransactions: 'আরও লেনদেন লোড করুন',
  loadMoreUsers: 'আরও ব্যবহারকারী লোড করুন',
  location: 'অবস্থান',
  lockConfirm: '🔒 লক নিশ্চিত করুন',
  locked: 'লক করা',
  lockMachine: 'মেশিন লক করুন',
  lockWarning: 'Teltonika GPS-এর মাধ্যমে মেশিন ইগনিশন দূর থেকে বন্ধ হবে।',
  loginAs: 'লগইন করছেন',
  loginChangeRole: 'ভূমিকা পরিবর্তন',
  loginClientPortalSubtitle: 'নির্মাণ মেশিনারি বুক করতে সাইন ইন করুন',
  loginEmailHint: 'অ্যাডমিন লগইনের জন্য নিবন্ধিত ইমেইল ব্যবহার করুন।',
  loginFailedGeneric: 'লগইন ব্যর্থ — অনুগ্রহ করে আবার চেষ্টা করুন',
  loginIAmQuestion: 'আমি কে…?',
  loginModeOtp: 'OTP লগইন',
  loginModePassword: 'পাসওয়ার্ড',
  loginNewHereRegister: 'নতুন? নিবন্ধন',
  loginOtpDevHint: 'Development: SMS না এলে API server log-এ OTP দেখুন।',
  loginOtpHint: 'আপনার নিবন্ধিত মোবাইল নম্বরে ৬ সংখ্যার OTP পাঠানো হবে।',
  loginOtpSentTo: 'OTP পাঠানো হয়েছে:',
  loginOwnerPortalSubtitle: 'ফ্লিট ও নিবন্ধন পরিচালনার জন্য সাইন ইন করুন',
  loginPhoneHint: 'গ্রাহক, মালিক ও অপারেটর লগইনের জন্য নিবন্ধিত মোবাইল নম্বর ব্যবহার করুন।',
  loginPickRoleHint: 'নিবন্ধিত? ভূমিকা বেছে নিন। নতুন? নিচে Join Us।',
  loginPortalAdminSubtitle: 'প্ল্যাটফর্ম নিয়ন্ত্রণ ও অনুমোদন',
  loginPortalAdminTitle: 'অ্যাডমিন পোর্টাল',
  loginPortalClientSubtitle: 'নির্মাণ মেশিনারি বুক করতে সাইন ইন',
  loginPortalClientTitle: 'গ্রাহক পোর্টাল',
  loginPortalOperatorSubtitle: 'নিয়োজিত মেশিন ও লগের জন্য সাইন ইন',
  loginPortalOperatorTitle: 'অপারেটর পোর্টাল',
  loginPortalOwnerSubtitle: 'ফ্লিট ও নিবন্ধন পরিচালনায় সাইন ইন',
  loginPortalOwnerTitle: 'মালিক পোর্টাল',
  loginRoleAdminDesc: 'প্ল্যাটফর্ম নিয়ন্ত্রণ, অনুমোদন ও অপারেশন',
  loginRoleClientDesc: 'নির্মাণ প্রকল্পের জন্য মেশিনারি বুক করুন',
  loginRoleClientShort: 'গ্রাহক',
  loginRoleOperatorDesc: 'নিয়োজিত মেশিন ও দৈনিক লগ',
  loginRoleOwnerDesc: 'ফ্লিট, আয় ও উপলব্ধতা পরিচালনা',
  loginRoleOwnerShort: 'মালিক',
  loginSendingOtp: 'OTP পাঠানো হচ্ছে...',
  loginSendOtp: 'OTP পাঠান',
  loginSignInShort: 'সাইন ইন',
  loginTabOtp: 'OTP',
  loginTabPassword: 'পাসওয়ার্ড',
  loginVerifyingOtp: 'Verify হচ্ছে...',
  loginVerifyOtp: 'Verify & Sign In',
  logout: 'লগআউট',
  sessionRevokedAlert: 'আপনি অন্য ডিভাইসে লগ ইন আছেন। অনুগ্রহ করে আবার লগইন করুন।',
  machine: 'মেশিন',
  machineDefaultLabel: 'মেশিন',
  machineDetails: 'মেশিন ও অপারেটর বিবরণ',
  machineDetailsTitle: 'মেশিন বিবরণ',
  machineDispatchedAt: 'মেশিন পাঠানো হয়েছে — {when}',
  machineHours: 'মেশিন ঘণ্টা',
  machineIdLabel: 'মেশিন ID',
  machineInfo: 'মেশিন তথ্য',
  machineLabel: 'মেশিন',
  machineLog: 'মেশিন লগ',
  machineReg: 'মেশিন নিবন্ধন ফর্ম',
  machineRegistrationSubmitted: 'মেশিন নিবন্ধন জমা হয়েছে! DE দল ২৪ ঘণ্টার মধ্যে যাচাই করবে।',
  machineRegistrationTitle: 'মেশিন নিবন্ধন',
  machines: 'মেশিন',
  machineStatus: 'মেশিন অবস্থা',
  machineStatusTitle: 'মেশিন অবস্থা',
  marketingBackHome: 'ওয়েবসাইটে ফিরে যান',
  marketingBadge: 'LIVE OPERATIONS · KARAD, SATARA',
  marketingBuiltFor: 'নির্ভুলতা, সম্মতি ও গতি চাই এমন ভারতীয় নির্মাণ দলের জন্য।',
  marketingCtaBook: 'মেশিন বুক করুন',
  marketingCtaLogin: 'Development Express খুলুন — Login',
  marketingCtaWhatsApp: 'WhatsApp করুন',
  marketingFooterRights: '2026 Development Express · Karad, Satara · All rights reserved',
  marketingHeadline: 'মহারাষ্ট্রের leading machinery rental platform',
  marketingLead: 'Real-time GPS tracking, digital wallet payments, and automated operations for construction machinery. Serving Maharashtra since 2011.',
  marketingNavContact: 'যোগাযোগ',
  marketingNavLogin: 'প্ল্যাটফর্ম লগইন →',
  marketingNavServices: 'সেবা',
  marketingNavTech: 'Technology',
  marketingServicesTitle: 'আমরা কী সরবরাহ করি',
  marketingStatDigital: 'Digital payments',
  marketingStatFleet: 'Live machines',
  marketingStatYears: 'বছরের অভিজ্ঞতা',
  marketingSvcOps: 'Full operations stack',
  marketingSvcOpsSub: 'Owner, operator, and client — one platform.',
  marketingSvcPay: 'Wallet-only settlements',
  marketingSvcPaySub: 'GST-ready invoicing — no cash on site.',
  marketingSvcTrack: 'GPS & live status',
  marketingSvcTrackSub: 'Teltonika-linked fleet visibility for every booking.',
  marketingTechLead: 'Development Express ties bookings, compliance, and field telemetry into a single hardened workflow — from first enquiry to final invoice.',
  md: 'MD',
  mediumTrend: 'MEDIUM Trend',
  minAdvanceRequired: 'ন্যূনতম অগ্রিম প্রয়োজন',
  minimumAdvance: 'ন্যূনতম অগ্রিম প্রয়োজন',
  minimumRecharge: 'UPI/কার্ডের জন্য ন্যূনতম ₹1',
  mobileNumber: 'মোবাইল নম্বর',
  monthMachineSummary: 'এই মাসের মেশিন',
  months: 'মাস',
  monthTotalLabel: 'মাসের মোট',
  moreAvailable: 'আরও উপলব্ধ',
  moUnit: 'মাস',
  myBookings: 'আমার বুকিং',
  myClientRating: 'আমার গ্রাহক রেটিং',
  myMachines: 'আমার মেশিন',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'নেট আয় (মাস)',
  netPaid: 'নেট প্রদত্ত',
  netPayable: 'নেট প্রদেয়',
  netReceived: 'নেট প্রাপ্ত',
  netReceivedCaps: 'নেট প্রাপ্ত',
  neverText: 'কখনো নয়',
  newBooking: 'নতুন বুকিং',
  newClientRegister: 'নতুন গ্রাহক? এখানে নিবন্ধন করুন',
  newClientRegistration: 'নতুন গ্রাহক নিবন্ধন',
  newPassword: 'নতুন পাসওয়ার্ড',
  nextText: 'পরবর্তী',
  noAlerts: 'কোনো সতর্কতা নেই!',
  noAlertsNow: 'এখন কোনো সতর্কতা নেই।',
  noBankRefund: '❌ ব্যাংক রিফান্ড নেই — শুধু ওয়ালেট ক্রেডিট',
  noBookings: 'কোনো সক্রিয় বুকিং নেই',
  noBookingsAccount: 'এই অ্যাকাউন্টে এখনও বুকিং নেই।',
  noBookingsYet: 'এখনো কোনো বুকিং নেই',
  noClientFeedbackYet: 'এখনো গ্রাহক রেটিং নেই। ডিসপ্যাচের পর গ্রাহক প্রতিক্রিয়া এখানে দেখা যাবে।',
  noDlqItems: 'কোনো DLQ আইটেম নেই',
  noFileSelected: 'কোনো ফাইল নির্বাচিত নয়',
  noMachinesDashboard: 'এখনো কোনো মেশিন নেই। ফ্লিট যোগ করতে মেশিন নিবন্ধন ব্যবহার করুন।',
  noMachinesTrack: 'ট্র্যাক করার মেশিন নেই',
  noMachinesTrackHint: 'GPS ট্র্যাকিংয়ের জন্য মেশিন নিবন্ধন করুন।',
  noMachinesYet: 'এখনো কোনো মেশিন নিবন্ধিত নয়',
  noMoreAuditLogs: 'বর্তমান ফিল্টারের জন্য আর কোনো অডিট লগ নেই।',
  noRecentApiSloBreach: 'সাম্প্রতিক API SLO breach সংকেত নেই।',
  noRecentFailedLogins: 'সাম্প্রতিক ব্যর্থ লগইন চেষ্টা নেই।',
  noRefund: 'রিফান্ড নীতি নেই',
  normalText: 'সাধারণ',
  noSecuritySignalsFound: 'কোনো নিরাপত্তা সংকেত পাওয়া যায়নি।',
  noTransactionsFilter: 'নির্বাচিত ফিল্টারের জন্য লেনদেন নেই।',
  off: 'OFF',
  officeLabel: 'অফিস',
  on: 'ON',
  operator: 'অপারেটর',
  operatorFeedbackColumn: 'অপারেটর প্রতিক্রিয়া',
  operatorFeedbackSaved: 'ধন্যবাদ! আপনার প্রতিক্রিয়া সংরক্ষিত হয়েছে।',
  operatorFeedbackSubmitted: 'আপনার প্রতিক্রিয়া',
  operatorFeedbackTitle: 'অপারেটর প্রতিক্রিয়া',
  operatorPortal: 'অপারেটর পোর্টাল',
  operatorRole: 'অপারেটর',
  operators: 'অপারেটর',
  operatorSatisfactionQuestion: 'আপনি কি অপারেটরে সন্তুষ্ট?',
  operatorSuggestionPlaceholder: 'পরামর্শ বা প্রতিক্রিয়া (ঐচ্ছিক)',
  optionalLabel: '(ঐচ্ছিক)',
  otpCode: 'OTP কোড',
  overview: 'সংক্ষিপ্ত বিবরণ',
  ownerBookingsAllLoaded: ' (সব লোড)',
  ownerBookingsMoreAvailable: ' (আরও উপলব্ধ)',
  ownerInfo: 'মালিকের তথ্য',
  ownerPortal: 'মালিক পোর্টাল',
  ownerRole: 'মেশিন মালিক',
  owners: 'মালিক',
  password: 'পাসওয়ার্ড',
  passwordsMustMatch: 'পাসওয়ার্ড ও নিশ্চিতকরণ একই হতে হবে।',
  pastIssuesTitle: 'পূর্বের সমস্যা',
  paymentBreakdownTitle: 'পেমেন্ট বিবরণ — April 2026',
  paymentCycle: 'পেমেন্ট চক্র',
  paymentFailed: 'পেমেন্ট ব্যর্থ! অনুগ্রহ করে আবার চেষ্টা করুন।',
  paymentHistory: 'পেমেন্ট ইতিহাস',
  paymentHistoryTitle: 'পেমেন্ট ইতিহাস',
  paymentMethods: 'পেমেন্ট পদ্ধতি',
  paymentMode: 'পেমেন্ট পদ্ধতি',
  paymentSuccess: 'পেমেন্ট সফল!',
  payNow: 'এখনই পেমেন্ট',
  payNowText: 'এখনই পেমেন্ট করুন',
  pdfInvoiceFailed: 'ইনভয়েস PDF তৈরি করা যায়নি। আবার চেষ্টা করুন।',
  pdfReportFailed: 'রিপোর্ট PDF তৈরি করা যায়নি। আবার চেষ্টা করুন।',
  pdiCompleted: '✅ PDI / Safety inspection সম্পন্ন',
  pdiCrawlerHint: 'Crawler plant: pollution (PUC) প্রয়োজন নেই — মেশিন RTO রোড-registered নয়।',
  pdiInfo: 'PDI পরীক্ষা',
  pdiInsuranceApplicable: '✅ Insurance / cover (if applicable)',
  pdiInsuranceValid: '✅ Insurance valid & up to date',
  pdiPollutionValid: '✅ Pollution certificate (PUC) valid',
  pdiTitle: 'Pre-Delivery Inspection (PDI)',
  penaltyDeduct: 'বাতিল জরিমানা (১ ঘণ্টা)',
  pending: 'মুলতুবি',
  pendingApproval: 'অনুমোদন মুলতুবি',
  pendingCount: '{count} মুলতুবি',
  pendingDispatch: 'ডিসপ্যাচ মুলতুবি',
  perDay: 'প্রতি দিন',
  perHour: 'প্রতি ঘণ্টা',
  perMonth: 'প্রতি মাস',
  perWeek: 'প্রতি সপ্তাহ',
  phone: 'ফোন',
  platform: 'নির্মাণ ব্যবস্থাপনা প্ল্যাটফর্ম',
  platformAgreement: 'প্ল্যাটফর্ম চুক্তি',
  policyLabel: 'নীতি',
  policyTopicBooking: 'বুকিং',
  policyTopicCancellation: 'বাতিল',
  policyTopicContact: 'যোগাযোগ',
  policyTopicGst: 'GST',
  policyTopicHours: 'সাপোর্ট সময়',
  portalBackLink: 'পোর্টাল',
  portalClient: 'গ্রাহক',
  portalClientSub: 'মেশিনারি বুক করুন',
  portalNewClientRegister: 'নতুন গ্রাহক? নিবন্ধন',
  portalNewOwnerRegister: 'নতুন মালিক? নিবন্ধন',
  portalOwner: 'মালিক',
  portalOwnerSub: 'ফ্লিট ব্যবস্থাপনা',
  portalStaffAdmin: 'অ্যাডমিন',
  portalStaffOperator: 'অপারেটর',
  portalWelcome: 'স্বাগতম',
  portalWelcomeHint: 'চালিয়ে যেতে আপনার পোর্টাল নির্বাচন করুন',
  quantityLabel: 'পরিমাণ',
  quickIssueReport: 'দ্রুত সমস্যা রিপোর্ট',
  quickRechargeUpi: 'UPI দিয়ে দ্রুত রিচার্জ',
  quickSelect: 'দ্রুত নির্বাচন:',
  rateCard: 'রেট কার্ড (অপারেটর সহ)',
  rateLimitTelemetryTitle: 'Rate Limit Telemetry',
  rateOperatorWork: 'অপারেটরের কাজ রেট করুন (১–৫ stars)',
  rating: 'রেটিং',
  receiptId: 'রসিদ ID',
  recentAlerts: 'সাম্প্রতিক সতর্কতা',
  recentFailedLoginsTitle: 'সাম্প্রতিক ব্যর্থ লগইন',
  recentLabel: 'সাম্প্রতিক',
  recharge: 'রিচার্জ',
  rechargeFirst: '⚡ প্রথমে ওয়ালেট রিচার্জ করুন',
  rechargeWallet: '+ ওয়ালেট রিচার্জ',
  ref: 'রেফারেন্স নম্বর',
  refreshingText: 'রিফ্রেশ হচ্ছে...',
  refreshText: 'রিফ্রেশ',
  regCapacitySpecs: 'ক্ষমতা / বিবরণ',
  regDocCrawlerHint: 'Crawler (excavator): chassis plate, machine purchase invoice, machine photo ও ID প্রয়োজন। Insurance optional.',
  regDocWheeledHint: 'Wheeled: RC (RTO), insurance, PUC ও ID প্রয়োজন (প্রতি 5MB)।',
  regEquipmentCategory: 'সরঞ্জাম বিভাগ *',
  regFailed: 'নিবন্ধন ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।',
  regFileSizeError: 'প্রতিটি document 5MB বা কম হতে হবে',
  regFileTypeError: 'শুধু PDF, JPG, PNG বা WEBP ফাইল অনুমোদিত',
  regFleetIdOptional: 'ফ্লিট / chassis ID (ঐচ্ছিক)',
  register: 'মেশিন নিবন্ধন',
  registerAction: 'নিবন্ধন করুন',
  registering: 'নিবন্ধন হচ্ছে...',
  registerMachine: 'মেশিন নিবন্ধন',
  registrationPending: 'অ্যাডমিন ২৪ ঘণ্টার মধ্যে আপনার অ্যাকাউন্ট সক্রিয় করবেন।',
  registrationSuccess: 'নিবন্ধন সফল!',
  regMachineCategory: 'মেশিন বিভাগ *',
  regMachineInfoTitle: 'মেশিন তথ্য',
  regMachineIntro: 'শুধুমাত্র নির্মাণ heavy equipment — ট্রাক/পরিবহন নয়। Wheeled plant (যেমন JCB 3DX)-এর RTO; crawler plant (Poclain, dozer) শুধু সাইটে — RTO passing নেই।',
  regMachineNameModel: 'মেশিনের নাম / মডেল',
  regMobilityTracked: 'Crawler',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer, crawler crane — সাইট plant, RTO passing নেই',
  regMobilityWheeled: 'Wheeled',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) সহ নির্মাণ plant',
  machineFinancialSection: 'মেশিন ক্রয় বিবরণ (ঐচ্ছিক)',
  machineOwnershipType: 'মালিকানার ধরন',
  machineOwnershipNew: 'নতুন মেশিন',
  machineOwnershipUsed: 'আসল মালিক',
  machineOwnershipSecondHand: 'পূর্ব-মালিকানা',
  machinePurchasePrice: 'ক্রয় মূল্য (₹)',
  machinePurchasePriceHint: 'এই মেশিনের জন্য আপনি যে পরিমাণ দিয়েছেন',
  machinePurchaseDate: 'ক্রয় তারিখ',
  machineYearOfManufacture: 'উৎপাদনের বছর',
  machineLoanSection: 'এই মেশিনে আমার loan আছে',
  machineLoanAmount: 'Loan পরিমাণ (₹)',
  machineLoanEmi: 'মাসিক EMI (₹)',
  machineLoanTenure: 'Loan মেয়াদ (মাস)',
  machineLoanStartDate: 'Loan শুরুর তারিখ',
  machineFuelConsumption: 'জ্বালানি খরচ (L/hr)',
  machineMonthlyOperatingExpenses: 'মাসিক পরিচালন ব্যয়',
  machineOperatorMonthlySalary: 'অপারেটর মাসিক বেতন',
  machineServiceMonthly: 'সার্ভিস / রক্ষণাবেক্ষণ (মাসিক)',
  machineBreakdownMonthly: 'ব্রেকডাউন / মেরামত (মাসিক গড়)',
  machineMaterialsMonthly: 'উপকরণ / ভোগ্যপণ্য (মাসিক)',
  recoveryPlan: 'রিকভারি প্ল্যান',
  recoveryOnTrack: 'সঠিক পথে',
  recoveryNeedsAttention: 'মনোযোগ প্রয়োজন',
  recoveryActionRequired: 'পদক্ষেপ প্রয়োজন',
  recoveryAddPrice: 'রিকভারি প্ল্যান দেখতে ক্রয় মূল্য যোগ করুন',
  recoveryProgress: 'বিনিয়োগ উদ্ধার',
  recoveryDailyNet: 'দৈনিক নিট আয়',
  recoveryDays: 'পুনরুদ্ধার মেয়াদ',
  recoveryProjectedDate: 'প্রক্ষেপিত পুনরুদ্ধার তারিখ',
  recoveryRoi: 'বার্ষিক রিটার্ন',
  recoveryCurrentValue: 'বর্তমান মেশিন মূল্য',
  editFinancialDetails: 'আর্থিক বিবরণ সম্পাদনা করুন',
  financialDetailsSaved: 'আর্থিক বিবরণ সংরক্ষিত',
  recoveryBackfillNudge: 'রিকভারি ট্র্যাকিং আনলক করতে {{count}}টি মেশিনে ক্রয়ের বিবরণ যোগ করুন',
  dieselPriceTitle: 'ডিজেলের দাম',
  dieselPriceUpdate: 'ডিজেলের দাম আপডেট করুন',
  dieselPriceLatest: 'সর্বশেষ দাম',
  dieselPriceNoRecord: 'ডিজেলের দাম রেকর্ড নেই',
  dieselPricePerLitre: 'লিটার দাম (₹)',
  dieselQuantity: 'ভরা পরিমাণ (লিটার)',
  dieselTaluka: 'শহর / এলাকা',
  bookingAttachment: 'অ্যাটাচমেন্ট নির্বাচন করুন',
  bookingAttachmentNone: 'কোনো নির্দিষ্ট অ্যাটাচমেন্ট নেই',
  bookingWorkDescription: 'কাজের বিবরণ',
  bookingWorkDescriptionPlaceholder: 'যেমন ভিত্তি খনন, ট্রেঞ্চিং, পাইপলাইন কাজ',
  bookingAttachmentLabel: 'অ্যাটাচমেন্ট',
  bookingSiteLabel: 'সাইট',
  bookingWorkLabel: 'কাজ',
  termsAccept: "আমি শর্তাবলীতে সম্মত",
  termsRequired: "নিবন্ধনের জন্য শর্তাবলী গ্রহণ করা আবশ্যক",
  termsLink: "শর্তাবলী",
  clientBlacklisted: "ব্ল্যাকলিস্ট",
  clientBlacklistReason: "ব্ল্যাকলিস্টের কারণ",
  clientBlacklistConfirm: "এই ক্লায়েন্টকে ব্ল্যাকলিস্ট করবেন?",
  clientUnblacklist: "ব্ল্যাকলিস্ট থেকে সরান",
  blacklistedClients: "ব্ল্যাকলিস্ট ক্লায়েন্ট",
  blacklistedClientsEmpty: "কোনো ব্ল্যাকলিস্ট ক্লায়েন্ট নেই",
  managerAccessRestricted: "অর্থায়ন অ্যাক্সেস সীমিত। ওম চাভান-এর সাথে যোগাযোগ করুন।",
  managerSection: "ম্যানেজার",
  managerAdd: "ম্যানেজার যোগ করুন",
  managerName: "ম্যানেজারের নাম",
  managerEmail: "ম্যানেজার ইমেইল",
  managerPassword: "অস্থায়ী পাসওয়ার্ড",
  managerCreated: "ম্যানেজার অ্যাকাউন্ট তৈরি হয়েছে",
  managerCredentialsTitle: "ম্যানেজার লগইন তথ্য",
  managerCredentialsSubtitle: "এই তথ্য এখনই সংরক্ষণ করুন — পাসওয়ার্ড পরে ফিরে পাওয়া যাবে না",
  managerCredentialsSaved: "আমি তথ্য সংরক্ষণ করেছি",
  managerLoginUrl: "লগইন URL",
  managerActivity: "ম্যানেজার কার্যকলাপ",
  managerActivityEmpty: "এখনও কোনো কার্যকলাপ রেকর্ড হয়নি",
  managerActivityViewAll: "সব কার্যকলাপ দেখুন",
  onboardingTitle: "শুরু করুন",
  onboardingAccountApproved: "অ্যাকাউন্ট অনুমোদিত",
  onboardingKycComplete: "KYC যাচাই সম্পূর্ণ",
  onboardingKycPending: "KYC যাচাই সম্পূর্ণ করুন",
  onboardingKycRejected: "KYC প্রত্যাখ্যাত — আবার জমা দিন",
  onboardingWalletFunded: "ওয়ালেটে ব্যালেন্স আছে",
  onboardingWalletEmpty: "বুকিংয়ের জন্য ওয়ালেট ব্যালেন্স যোগ করুন",
  pushEnablePrompt: "তাৎক্ষণিক আপডেটের জন্য পুশ নোটিফিকেশন চালু করুন",
  downloadDisputeStatement: "বিরোধ বিবৃতি ডাউনলোড করুন",
  downloadInvoice: "ইনভয়েস ডাউনলোড করুন",
  bookAgain: "আবার বুক করুন",
  machineNoLongerAvailable: "মেশিন আর উপলব্ধ নেই",
  downloadHistoryPdf: "ইতিহাস PDF ডাউনলোড করুন",
  onboardingFirstBooking: "আপনার প্রথম বুকিং করুন",
  onboardingAllDone: "আপনি প্রস্তুত!",
  onboardingTrackerTitle: "অনবোর্ডিং অগ্রগতি",
  onboardingTrackerTarget: "অনবোর্ডিং লক্ষ্য: 48 ঘণ্টা",
  onboardingTrackerInProgress: "চলছে",
  onboardingTrackerActionRequired: "ব্যবস্থা প্রয়োজন",
  onboardingTrackerComplete: "সম্পূর্ণ",
  onboardingTrackerPending: "অপেক্ষমাণ",
  onboardingTrackerPhase1: "নিবন্ধন",
  onboardingTrackerPhase2: "KYC যাচাই",
  onboardingTrackerPhase3: "মেশিন নিবন্ধন",
  onboardingTrackerPhase4: "প্রথম বুকিং প্রস্তুত",
  onboardingTrackerHelper1: "মেশিন নিবন্ধন খুলতে আধার + সেলফি আপলোড করুন",
  onboardingTrackerHelper2: "KYC পর্যালোচনায় — সাধারণত 24 ঘণ্টার মধ্যে",
  onboardingTrackerHelper3: "KYC প্রত্যাখ্যাত — নথি আবার জমা দিন",
  onboardingTrackerHelper4: "KYC অনুমোদিত — আপনার প্রথম মেশিন যোগ করুন",
  onboardingTrackerHelper5: "মেশিন অ্যাডমিন পর্যালোচনায়",
  onboardingTrackerHelper6: "মেশিন লাইভ — প্রথম বুকিংয়ের অপেক্ষা",
  onboardingTrackerPhaseLabel: "ধাপ",
  alertsAndNotifications: 'সতর্কতা ও বিজ্ঞপ্তি',
  dieselFuelCostPerHour: 'ঘণ্টায় জ্বালানি খরচ',
  dieselPercentOfRate: 'আপনার ঘণ্টার হারের',
  dieselPriceSaved: 'ডিজেলের দাম সংরক্ষিত',
  dieselRateSuggestion: 'হার পরামর্শ',
  dieselRateIncrease: 'ডিজেল বেড়েছে — হার বাড়ানোর কথা ভাবুন',
  dieselRateDecrease: 'ডিজেল কমেছে — বুকিংয়ের জন্য হার কমান',
  dieselSuggestedRate: 'প্রস্তাবিত হার',
  dieselHistory: 'দামের ইতিহাস',
  dieselNoHistory: 'এখনও ডিজেল দামের ইতিহাস নেই',
  dieselColDate: 'তারিখ',
  dieselColPrice: 'দাম/লিটার',
  dieselColQty: 'পরিমাণ',
  dieselColSource: 'উৎস',
  dieselUploadReceipt: 'রসিদ আপলোড',
  dieselExtractSuccess: 'রসিদ থেকে বের করা হয়েছে',
  dieselExtractFailed: 'বের করা যায়নি — ম্যানুয়ালি লিখুন',
  applyRateSuggestion: '₹{{rate}}/ঘণ্টা প্রয়োগ করুন',
  rateSuggestionApplied: 'হার সফলভাবে আপডেট হয়েছে',
  marketPosition: 'বাজার অবস্থান',
  marketBelowMarket: 'বাজারের চেয়ে কম',
  marketCompetitive: 'প্রতিযোগিতামূলক',
  marketAboveMarket: 'বাজারের চেয়ে বেশি',
  marketNoData: 'আপনার এলাকার জন্য এখনও বাজার ডেটা নেই',
  marketSubmitRate: 'বাজার হার জমা দিন',
  marketCity: 'শহর / এলাকা',
  marketMinRate: 'আপনার এলাকায় সর্বনিম্ন হার (₹/ঘণ্টা)',
  marketMaxRate: 'আপনার এলাকায় সর্বোচ্চ হার (₹/ঘণ্টা)',
  marketRateSubmitted: 'বাজার হার জমা হয়েছে — ধন্যবাদ!',
  marketDataPoints: '{{count}} জমার উপর ভিত্তি করে',
  marketRange: '{{city}}-এ বাজার',
  marketSourceLocal: '{{city}} এলাকার হারের উপর ভিত্তি করে',
  marketSourcePlatform: 'প্ল্যাটফর্ম-ব্যাপী হারের উপর ভিত্তি করে',
  regPremiumOnboarding: 'Premium onboarding',
  regRtoNumber: 'RTO নিবন্ধন নম্বর *',
  regSelectType: 'ধরন নির্বাচন করুন…',
  regSubmitBtn: '✅ নিবন্ধন জমা দিন',
  regTagNoRto: 'RTO নেই',
  regTagRto: 'RTO',
  regYearManufacture: 'উৎপাদনের বছর *',
  remoteLockAlert: 'Teltonika GPS device এই মেশিনে ইনস্টল হলে remote lock সক্রিয় হবে। DE support-এ যোগাযোগ করুন।',
  remoteLockMachine: '🔒 রিমোট লক মেশিন',
  replaceFile: 'পরিবর্তন',
  reports: 'রিপোর্ট',
  reportText: 'রিপোর্ট',
  resetMethodEmail: 'ইমেইল লিংক',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'পাসওয়ার্ড রিসেট করতে ব্যর্থ। নতুন লিংক অনুরোধ করুন।',
  resetPasswordIntro: 'ন্যূনতম ৮ অক্ষরের শক্তিশালী পাসওয়ার্ড বেছে নিন।',
  resetPasswordMinLength: 'পাসওয়ার্ড ন্যূনতম ৮ অক্ষর হতে হবে।',
  resetPasswordMissingToken: 'রিসেট লিংক নেই বা অবৈধ। লগইন থেকে Forgot password ব্যবহার করুন।',
  resetPasswordSubmit: 'পাসওয়ার্ড আপডেট করুন',
  resetPasswordSuccess: 'পাসওয়ার্ড আপডেট হয়েছে। লগইনে ফিরছে...',
  resetPasswordTitle: 'নতুন পাসওয়ার্ড সেট করুন',
  resetPasswordUpdating: 'আপডেট হচ্ছে...',
  resetText: 'রিসেট',
  retryDlqItemTitle: 'DLQ আইটেম পুনরায় চেষ্টা করুন',
  retryFailedForDlq: 'DLQ আইটেমের জন্য পুনরায় চেষ্টা ব্যর্থ',
  retryReasonAuditPlaceholder: 'পুনরায় চেষ্টার কারণ (অডিটের জন্য)',
  retryText: 'আবার চেষ্টা করুন',
  revenue: 'আয়',
  running: 'চলছে',
  satisfiedNo: 'অসন্তুষ্ট',
  satisfiedYes: 'হ্যাঁ, সন্তুষ্ট',
  save: 'সংরক্ষণ',
  scanToPay: 'পেমেন্টের জন্য স্ক্যান করুন',
  scheduleColFeedback: 'প্রতিক্রিয়া',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'মোট',
  scheduleColType: 'ধরন',
  securitySignalsTitle: 'নিরাপত্তা সংকেত',
  selectBook: 'এই মেশিন বুক করুন →',
  selectCalc: '📋 নির্বাচন ও খরচ দেখুন →',
  selectedMachineText: 'নির্বাচিত মেশিন',
  selectFile: 'ফাইল নির্বাচন',
  selectMachineFirst: 'প্রথমে মেশিন নির্বাচন করুন',
  selectQty: 'পরিমাণ নির্বাচন',
  selectRole: 'ভূমিকা নির্বাচন করুন',
  send: 'পাঠান',
  sendEmail: 'ইমেইল পাঠান',
  sendWhatsapp: 'WhatsApp-এ পাঠান',
  settlements: 'নিষ্পত্তি',
  show: 'দেখান',
  signIn: 'সাইন ইন করুন',
  signingIn: 'লগইন হচ্ছে...',
  signupCompanyName: 'কোম্পানির নাম',
  signupContactName: 'যোগাযোগের নাম',
  signupCreatePassword: 'পাসওয়ার্ড তৈরি করুন',
  signupReenterPassword: 'পাসওয়ার্ড আবার লিখুন',
  signupSectionCompany: 'কোম্পানি',
  signupSectionContact: 'আপনার বিবরণ',
  signupSectionSecurity: 'নিরাপত্তা',
  sinceExcellence: '২০১১ থেকে · ১৫ বছরের শ্রেষ্ঠত্ব',
  sinceLabel: 'থেকে',
  sloBreachRisk: 'SLO BREACH RISK',
  sloHealthy: 'SLO HEALTHY',
  speed: 'গতি',
  staleText: 'পুরনো',
  status: 'অবস্থা',
  statusCancelled: 'বাতিল',
  bookingClosed: 'বন্ধ',
  sectionNew: 'নতুন',
  sectionAccepted: 'গৃহীত',
  sectionActive: 'সক্রিয়',
  sectionDispatched: 'ডিসপ্যাচ',
  sectionCompleting: 'সম্পন্ন হচ্ছে',
  sectionDisputed: 'বিরোধ',
  sectionCompleted: 'সম্পন্ন',
  sectionClosed: 'বন্ধ',
  statusCompleted: 'সম্পন্ন',
  stopped: 'থেমেছে',
  submit: 'জমা দিন',
  submitOperatorFeedback: 'প্রতিক্রিয়া জমা দিন',
  submittedRegistrations: 'জমা দেওয়া নিবন্ধন',
  support: 'সহায়তা',
  supportPolicyBooking: 'শুধু ওয়ালেট অগ্রিম। সাইটে নগদ নয়।',
  supportPolicyCancellation: '১ ঘণ্টা জরিমানা; বাকি ওয়ালেটে।',
  supportPolicyContact: 'শুধু DE Support — সরাসরি অপারেটর যোগাযোগ নিষিদ্ধ।',
  supportPolicyGst: 'সব ইনভয়েসে 18% GST; Reports ট্যাবে ডাউনলোড।',
  supportPolicyHours: 'সোম–শনি, 9–7 IST',
  tableAtt: 'Att',
  tableChange: 'পরিবর্তন',
  tableDay: 'দিন',
  tableEnd: 'শেষ',
  tableHrs: 'ঘণ্টা',
  tableId: 'ID',
  tableIn: 'In',
  tableLevel: 'স্তর',
  tableMonth: 'মাস',
  tableNote: 'নোট',
  tableOut: 'Out',
  tableStart: 'শুরু',
  tagline: 'অবকাঠামোর স্বর্ণ মান',
  tax: 'কর',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express কমিশন: মোট বিলিংয়ের ১৫%',
  termFuel: 'মেশিনে সবসময় ৪০%+ জ্বালানি থাকতে হবে',
  termGps: 'GPS device (Teltonika) বাধ্যতামূলক — DE দ্বারা ইনস্টল',
  termGstTcs: 'GST TCS: GST regulations অনুযায়ী ১%',
  termNoDirectContact: 'সরাসরি গ্রাহক যোগাযোগ = তাৎক্ষণিক contract termination',
  termPaymentDays: 'গ্রাহক settlement-এর ৩ কার্যদিবসের মধ্যে পেমেন্ট',
  termTds: 'TDS deduction: Income Tax Act অনুযায়ী ২%',
  threeWorkingDays: '৩ কার্যদিবস',
  timeLabel: 'সময়',
  todayText: 'আজ',
  topSourceIp: 'শীর্ষ সোর্স IP',
  total: 'মোট',
  totalAdvanceLabel: 'অগ্রিম প্রদত্ত',
  totalBookingsText: 'মোট বুকিং',
  totalMachines: 'মোট মেশিন',
  totalSpent: 'মোট খরচ',
  tracking: 'GPS ট্র্যাকিং',
  transactionHistoryTitle: 'লেনদেন ইতিহাস',
  transactions: 'লেনদেন ইতিহাস',
  trustStatCompliant: 'সম্মতি',
  trustStatMachines: 'মেশিন',
  trustStatRating: 'রেটিং',
  txnDescription: 'বিবরণ',
  type: 'ধরন',
  understood: '✅ বুঝেছি — প্ল্যাটফর্ম ব্যবহার করব',
  understoodAction: 'বুঝেছি',
  unknownText: 'অজানা',
  updateFuel: 'জ্বালানি আপডেট',
  updateText: 'আপডেট',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'আপলোড',
  valEmail: 'বৈধ ইমেইল প্রয়োজন',
  valMachineName: 'মেশিনের নাম / model প্রয়োজন',
  valMachineType: 'অনুগ্রহ করে equipment category নির্বাচন করুন',
  valMobility: 'অনুগ্রহ করে wheeled বা crawler equipment ধরন নির্বাচন করুন',
  valOwnerName: 'মালিকের নাম প্রয়োজন',
  valPdiChecks: 'অনুগ্রহ করে সমস্ত required checks নিশ্চিত করুন',
  valPdiRequired: 'PDI confirmation প্রয়োজন',
  valPhone: 'বৈধ ফোন নম্বর প্রয়োজন',
  valRto: 'Wheeled machines-এর জন্য RTO registration number প্রয়োজন',
  valUploadMissing: 'অনুগ্রহ করে আপলোড করুন: {docs}',
  valYear: 'বৈধ year (YYYY) প্রয়োজন',
  viewMachines: '→ মেশিন দেখুন',
  wallet: 'ওয়ালেট',
  walletBalance: 'ওয়ালেট ব্যালেন্স',
  walletCredit: 'ওয়ালেট ক্রেডিট',
  walletDebit: 'ওয়ালেট ডেবিট',
  walletDeduct: 'অগ্রিম ওয়ালেট থেকে কাটা হবে · নগদ নয় · GST স্বয়ংক্রিয়ভাবে তৈরি',
  walletInsufficient: '❌ অপর্যাপ্ত',
  walletLowRecharge: 'ওয়ালেট ব্যালেন্স কম — পরবর্তী বুকিংয়ের আগে রিচার্জ',
  walletOnly: 'শুধু ওয়ালেট · নগদ গ্রহণযোগ্য নয়',
  walletOnlyPolicyDesc: 'সমস্ত লেনদেন শুধুমাত্র ওয়ালেটের মাধ্যমে। নগদ গ্রহণযোগ্য নয়।',
  walletOnlyPolicyTitle: 'শুধুমাত্র ওয়ালেট নীতি',
  walletRechargeTitle: 'ওয়ালেট রিচার্জ',
  walletSufficient: '✅ চালিয়ে যান',
  weeks: 'সপ্তাহ',
  whatsapp: 'WhatsApp',
  wksUnit: 'সপ্তাহ',
  year: 'বছর',
  yearsExperience: '{n} বছর',
  yourMessage: 'আপনার প্রশ্ন বা সমস্যা লিখুন...',
  // --- Recent feature strings ---
  retryLabel: 'আবার চেষ্টা করুন',
  payrollPreview: 'বেতন প্রিভিউ',
  payrollRun: 'বেতন চালান',
  payrollAlreadyRun: 'এই মাসের বেতন ইতিমধ্যে চালানো হয়েছে',
  payrollGross: 'মোট প্রদেয়',
  payrollNet: 'নিট প্রদেয়',
  payrollAdvanceDeducted: 'অগ্রিম কাটা',
  payrollRunSuccess: 'বেতন সফলভাবে চালানো হয়েছে',
  payrollNoAmount: 'এই মাসের জন্য প্রদেয় পরিমাণ নেই',
  payrollMonth: 'বেতন মাস',
  exportPayrollCsv: 'বেতন CSV এক্সপোর্ট',
  payrollExportMonth: 'বেতন এক্সপোর্ট মাস',
  payrollDailyRate: 'দৈনিক হার',
  payrollHistory: 'বেতন ইতিহাস',
  payrollNoHistory: 'এখনও কোনো বেতন চালানো হয়নি',
  payrollColMonth: 'মাস',
  payrollColGross: 'মোট',
  payrollColDeduction: 'অগ্রিম কাটা',
  payrollColNet: 'নেট বেতন',
  payrollColDate: 'তারিখ',
  downloadPayslip: 'পে স্লিপ ডাউনলোড',
  payslipTitle: 'মাসিক পে স্লিপ',
  payslipEarnings: 'আয়',
  payslipDeductions: 'কাটা',
  payslipDaysWorked: 'কাজের দিন',
  payslipGeneratedBy: 'Development Express দ্বারা তৈরি',
  operatorPayrollTitle: 'আমার বেতন',
  payrollMonthlySalary: 'মাসিক বেতন',
  payrollCurrentMonth: 'বর্তমান মাস',
  payrollPreviousMonth: 'আগের মাস',
  ownerAttendanceTitle: 'উপস্থিতি',
  ownerAttendanceEdit: 'সম্পাদনা',
  ownerAttendanceSave: 'সংরক্ষণ',
  ownerAttendanceNoRecords: 'এই মাসে উপস্থিতির রেকর্ড নেই',
  ownerAttendanceOverrideSuccess: 'উপস্থিতি আপডেট হয়েছে',
  ownerSalaryUpdated: 'বেতন সফলভাবে আপডেট হয়েছে',
  ownerSalaryEditBtn: 'বেতন সম্পাদনা',
  ownerSalaryNotSet: 'বেতন সেট নেই — পেরোলের জন্য বেতন সেট করুন',
  duration: "সময়কাল",
  durationLabel: 'সময়কাল',
  plQuotaLabel: 'PL কোটা',
  plUsed: 'ব্যবহৃত',
  plAllowed: 'অনুমোদিত',
  plRemaining: 'বাকি',
  plQuotaUpdated: 'PL কোটা আপডেট',
  plQuotaExhausted: 'PL কোটা শেষ — অবৈতনিক ছুটি হিসেবে চিহ্নিত',
  plRemainingLabel: 'বাকি PL',
  noAttendanceRecords: 'এখনও উপস্থিতির রেকর্ড নেই',
  noFuelLogs: 'এখনও জ্বালানি লগ নেই',
  noIssuesYet: 'এখনও কোনো সমস্যা রেকর্ড নেই',
  failedToLoad: 'ডেটা লোড করা যায়নি',
  failedToLoadReport: 'রিপোর্ট লোড করা যায়নি',
  failedToLoadIssues: 'সমস্যা লোড করা যায়নি',
  failedToLoadAlerts: 'সতর্কতা লোড করা যায়নি',
  noRecordsMonth: 'এই মাসে রেকর্ড নেই',
  underReview: 'পর্যালোচনাধীন',
  issueResolved: 'সমাধান হয়েছে',
  presentDaysLabel: 'উপস্থিত দিন',
  halfDaysLabel: 'অর্ধ দিন',
  absentDaysLabel: 'অনুপস্থিত দিন',
  totalHmrLabel: 'মোট HMR',
  noActiveBookingIdle: 'কোনো সক্রিয় বুকিং নেই — মেশিন নিষ্ক্রিয়',
  siteLocationNotCaptured: 'সাইট অবস্থান রেকর্ড হয়নি',
  siteLocationNotAvailable: 'সাইট অবস্থান উপলব্ধ নয়',
  bookingRefLabel: 'বুকিং Ref',
  alertPendingBookings: 'অমীমাংসিত বুকিং',
  alertPendingPayouts: 'অমীমাংসিত পেমেন্ট',
  alertLowFuel: 'কম জ্বালানি',
  alertOpenIssues: 'খোলা সমস্যা',
  noMachineRunning: 'বর্তমানে কোনো মেশিন চালু নেই',
  trackingEmptyHint: 'মেশিন পাঠানোর পর আপনার সক্রিয় বুকিং এখানে দেখা যাবে।',
  trackingUpdatedEvery5s: 'প্রতি ৫ সেকেন্ডে আপডেট',
  fuelLastOperatorUpdate: '(অপারেটরের শেষ আপডেট)',
  alertExtensionPending: 'বুকিং এক্সটেনশন মুলতুবি',
  alertConfirmCompletion: 'অনুগ্রহ করে কাজ সম্পন্ন নিশ্চিত করুন',
  alertWalletCredited: 'ওয়ালেটে যোগ হয়েছে',
  alertFeedbackRequest: 'কাজ সম্পন্ন — আপনার মতামত শেয়ার করুন',
  noLogsYet: 'এখনও কোনো কার্যকলাপ লগ হয়নি',
  todayActivityLog: 'আজকের কার্যকলাপ লগ',
  machineLogSubtitle: 'জ্বালানি, উপস্থিতি, সমস্যা — স্থানীয় সেশন লগ',
  timerPaused: 'Timer বিরতি',
  liveBookingTitle: 'লাইভ বুকিং',
  machineLogTimerHint: 'Timer Admin শুরু করেন। নিচে আপনার প্রকৃত কাজের সময় লিখুন — শেষে Mark Work Complete ক্লিক করুন।',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'উপস্থিতি',
  ownerAlertBookingPending: 'নতুন বুকিং আপনার অনুমোদনের জন্য মুলতুবি —',
  ownerAlertBookingHours: 'ঘণ্টা',
  ownerAlertPayoutPending: '₹{{amount}} পেমেন্ট স্থানান্তর মুলতুবি',
  ownerAlertFuelLow: 'জ্বালানি কম',
  ownerAlertFuelRemaining: 'অবশিষ্ট',
  ownerAlertIssue: 'সমস্যা নথিভুক্ত',
  iotGpsDevicesActive: 'GPS ডিভাইস সক্রিয়',
  iotDashcamsOnline: 'ড্যাশক্যাম অনলাইন',
  iotFuelSensorsActive: 'জ্বালানি সেন্সর সক্রিয়',
  iotMachinesLocked: 'মেশিন লক',
  iotDeviceStatus: 'IoT ডিভাইস অবস্থা',
  iotColMachine: 'মেশিন',
  iotColGps: 'GPS',
  iotColLocation: 'অবস্থান',
  iotColFuel: 'জ্বালানি %',
  iotColDashcam: 'ড্যাশক্যাম',
  iotColIgnition: 'ইগনিশন',
  iotColAction: 'কর্ম',
  iotStatusOnline: 'অনলাইন',
  iotStatusNotConnected: 'সংযুক্ত নয়',
  iotStatusLive: 'লাইভ',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'লক',
  iotNotConnectedBanner: 'IoT হার্ডওয়্যার এখনও ইনস্টল হয়নি। Teltonika ডিভাইস ইনস্টলেশনের পর GPS, ড্যাশক্যাম এবং রিমোট লক সুবিধা উপলব্ধ হবে।',
  fuelUpdateTitle: 'জ্বালানি আপডেট',
  fuelSensorAccuracyNote: 'অপারেটরের লগ করা জ্বালানির স্তর · ম্যানুয়াল এন্ট্রি',
  bookingsTab: 'বুকিং',
  unknownLabel: 'অজানা',
  naLabel: 'N/A',
  baseLabel: 'ভিত্তি',
  qtyLabel: 'পরিমাণ',
  actualHrsLabel: 'প্রকৃত ঘণ্টা',
  auditStatTotal: 'মোট',
  auditStatSecurity: 'নিরাপত্তা',
  auditStatActors: 'কর্তা',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'Non-Admin',
  kycDocLicense: 'লাইসেন্স',
  kycDocAadhaarFront: 'Aadhaar সামনে',
  kycDocAadhaarBack: 'Aadhaar পিছনে',
  kycDocPoliceVerification: 'পুলিশ যাচাই',
  kycVerification: 'KYC যাচাই',
  kycNotSubmitted: 'KYC জমা হয়নি',
  kycUnderReview: 'KYC পর্যালোচনাধীন',
  kycVerified: 'KYC যাচাইকৃত',
  kycRejected: 'KYC প্রত্যাখ্যাত',
  kycAadhaarFront: 'Aadhaar সামনে',
  kycAadhaarBack: 'Aadhaar পিছনে',
  kycSelfie: 'সেলফি',
  kycSubmitBtn: 'KYC নথি জমা দিন',
  kycSubmitSuccess: 'নথি জমা — পর্যালোচনাধীন',
  kycResubmit: 'আবার নথি জমা দিন',
  adminKycTitle: 'ক্লায়েন্ট KYC পর্যালোচনা',
  adminKycAllFilter: 'সব',
  adminKycNoSubmissions: 'এখনও KYC জমা নেই',
  adminOwnerKycTitle: 'মালিক KYC পর্যালোচনা',
  adminOwnerKycNoSubmissions: 'এখনও কোনো মালিক KYC জমা নেই',
  adminOperatorKycTitle: 'অপারেটর KYC পর্যালোচনা',
  adminOperatorKycNoSubmissions: 'এখনও কোনো অপারেটর KYC জমা নেই',
  kycRejectedWarning: 'আপনার KYC প্রত্যাখ্যান হয়েছে। অনুগ্রহ করে নথি পুনরায় জমা দিন।',
  kycNotSubmittedHint: 'বিশ্বস্ত অভিজ্ঞতার জন্য KYC সম্পূর্ণ করুন।',
  kycPendingHint: 'আপনার KYC পর্যালোচনাধীন।',
  kycGoToTab: 'KYC-তে যান',
  adminKycApproveBtn: 'অনুমোদন',
  adminKycRejectBtn: 'প্রত্যাখ্যান',
  adminKycViewDocs: 'নথি দেখুন',
  adminKycRejectReason: 'প্রত্যাখ্যানের কারণ',
  adminKycRereviewBtn: 'পুনরায় পর্যালোচনা',
  kycPan: 'PAN কার্ড',
  kycOwnerSubmitSuccess: 'নথি জমা — আপনার KYC পর্যালোচনাধীন',
  kycLicense: 'ড্রাইভিং লাইসেন্স',
  kycPoliceVerification: 'পুলিশ যাচাই',
  kycOperatorSubmitSuccess: 'নথি জমা — আপনার KYC পর্যালোচনাধীন',
  operatorKycRejectedAssign: 'এই অপারেটরের KYC প্রত্যাখ্যাত হয়েছে — পুনরায় অনুমোদিত না হওয়া পর্যন্ত তাদের নিয়োগ করা যাবে না।',
  operatorsColOperator: 'অপারেটর',
  operatorsColEmail: 'ইমেইল',
  operatorsColPhone: 'ফোন',
  operatorsColDocuments: 'নথি',
  operatorsColStatus: 'অবস্থা',
  operatorsDocumentsBtn: 'নথি ({{count}})',
  operatorsNoResults: 'কোনো অপারেটর পাওয়া যায়নি',
  operatorsAllTitle: 'সকল অপারেটর ({{count}})',
  operatorsKycDialogDesc: 'KYC নথি',
  bookingsCountLabel: '{{count}} বুকিং',
  complianceDates: 'সম্মতি তারিখ',
  complianceInsurance: 'বীমা',
  complianceRcBook: 'RC বই',
  compliancePuc: 'PUC',
  complianceNotSet: 'সেট নেই',
  complianceExpired: 'মেয়াদ শেষ',
  complianceExpiringSoon: 'শীঘ্রই মেয়াদ শেষ',
  complianceExpiringCritical: '৭ দিনে মেয়াদ শেষ',
  complianceValid: 'বৈধ',
  complianceUpdateBtn: 'সম্মতি তারিখ আপডেট করুন',
  complianceSaveBtn: 'সংরক্ষণ',
  complianceAlertsTitle: 'সম্মতি সতর্কতা',
  complianceAllCompliant: 'সব মেশিন সম্মতিপূর্ণ ✅',
  complianceColMachine: 'মেশিন',
  complianceColOwner: 'মালিক',
  complianceColInsurance: 'বীমা',
  complianceColRcBook: 'RC বই',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'শুরুর তারিখ',
  complianceEndDate: 'শেষ তারিখ',
  complianceExtractBtn: 'তারিখ স্বয়ংক্রিয়ভাবে পূরণ করতে নথি আপলোড করুন',
  complianceExtractSuccess: 'তারিখ বের করা হয়েছে — সংরক্ষণের আগে যাচাই করুন',
  complianceExtractError: 'তারিখ বের করা যায়নি — অনুগ্রহ করে ম্যানুয়ালি লিখুন',
  complianceExtracting: 'নথি পড়া হচ্ছে...',
  serviceHistory: 'সেবা ইতিহাস',
  serviceLastService: 'শেষ সেবা',
  serviceNoRecords: 'এখনও কোনো সেবা রেকর্ড নেই',
  serviceNextDue: 'পরবর্তী সেবা বাকি',
  serviceNextHmr: 'পরবর্তী সেবায়',
  serviceAddLog: 'সেবা লগ যোগ করুন',
  serviceDate: 'সেবা তারিখ',
  serviceType: 'সেবা ধরন',
  serviceHmr: 'সেবা HMR',
  serviceNextDate: 'পরবর্তী সেবা তারিখ',
  serviceWorkDone: 'কৃত কাজ',
  serviceNotes: 'নোট',
  serviceTypeRoutine: 'নিয়মিত',
  serviceTypeMajor: 'প্রধান',
  serviceTypeBreakdown: 'ত্রুটি',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'অন্যান্য',
  serviceOverdue: 'মেয়াদোত্তীর্ণ',
  serviceDueSoon: 'শীঘ্রই বাকি',
  fleetAnalytics: 'ফ্লিট বিশ্লেষণ',
  analyticsRevenue: 'মোট আয়',
  analyticsBookings: 'মোট বুকিং',
  analyticsHours: 'মোট ঘণ্টা',
  analyticsActiveMachines: 'সক্রিয় মেশিন',
  analyticsMonthlyTrend: 'মাসিক আয় প্রবণতা',
  analyticsMachineTable: 'মেশিন অনুযায়ী আয়',
  analyticsNoData: 'এই সময়ে কোনো সম্পূর্ণ বুকিং নেই',
  analyticsLastBooking: 'শেষ বুকিং',
  analytics3Months: '3 মাস',
  analytics6Months: '6 মাস',
  analytics12Months: '12 মাস',
  adminAnalytics: 'বিশ্লেষণ',
  adminFleetTitle: 'ফ্লিট বিশ্লেষণ',
  adminFleetPlatformRevenue: 'প্ল্যাটফর্ম আয়',
  adminFleetActiveOwners: 'সক্রিয় মালিক',
  adminFleetOwnerCol: 'মালিক',
  adminFleetMonthlyTrend: 'মাসিক আয়ের প্রবণতা',
  adminFleetMachineTable: 'মেশিন অনুযায়ী আয়',
  adminFleetNoData: 'এই সময়ে কোনো সম্পূর্ণ বুকিং নেই',
  adminFinancialIntelligence: 'মেশিন আর্থিক তথ্য',
  adminTotalInvested: 'মোট বিনিয়োগ',
  adminTotalEarned: 'মোট আয়',
  adminAvgRecovery: 'গড় পুনরুদ্ধার',
  adminBreakEvenRate: 'ব্রেক-ইভেন হার',
  adminProfitMargin: 'লাভের মার্জিন',
  adminNoFinancialData: 'এখনও আর্থিক তথ্য সহ কোনো মেশিন নেই',
  adminMachineDetail: 'মেশিন বিবরণ',
  adminCallOwner: 'মালিককে কল করুন',
  adminWhatsappOwner: 'WhatsApp মালিক',
  adminMarketRates: 'মার্কেট রেট জমা',
  adminMarketRateDelete: 'মুছুন',
  adminMarketRateDeleteConfirm: 'এই মার্কেট রেট জমা মুছবেন?',
  adminMarketRateDeleted: 'মার্কেট রেট মুছে ফেলা হয়েছে',
  adminMarketRateNoData: 'এখনও কোনো মার্কেট রেট জমা নেই',
  marketRateApprove: 'অনুমোদন করুন',
  marketRateReject: 'প্রত্যাখ্যান করুন',
  marketRateApproved: 'অনুমোদিত',
  marketRateRejected: 'প্রত্যাখ্যাত',
  marketRatePending: 'মুলতুবি',
  marketRateReviewed: 'মার্কেট রেট পর্যালোচনা হয়েছে',
  marketRatePendingReview: 'আপনার রেট জমা হয়েছে এবং অ্যাডমিন পর্যালোচনার জন্য মুলতুবি আছে।',
  marketRateEditApprove: 'সম্পাদনা ও অনুমোদন',
  marketRateEditMin: 'সংশোধিত ন্যূনতম রেট (₹/ঘণ্টা)',
  marketRateEditMax: 'সংশোধিত সর্বোচ্চ রেট (₹/ঘণ্টা)',
  adminPayrollOverview: 'বেতন সারসংক্ষেপ',
  adminPayrollTotalOperators: 'মোট অপারেটর',
  adminPayrollTotalGross: 'মোট প্রদেয়',
  adminPayrollTotalNet: 'মোট নেট প্রদেয়',
  adminPayrollNoData: 'এই মাসে বেতন ডেটা নেই',
  subTabSchedule: 'সময়সূচি',
  subTabHistory: 'ইতিহাস',
  subTabAnalytics: 'বিশ্লেষণ',
  clientAnalyticsTitle: 'বুকিং বিশ্লেষণ',
  clientAnalyticsSpend: 'মোট খরচ',
  clientAnalyticsHours: 'মোট ঘণ্টা',
  clientAnalyticsBookings: 'সম্পূর্ণ বুকিং',
  clientAnalyticsMachines: 'ব্যবহৃত মেশিন',
  clientAnalyticsAvgSpend: 'প্রতি বুকিং গড়',
  clientAnalyticsMonthlyTrend: 'মাসিক খরচ প্রবণতা',
  clientAnalyticsTopMachines: 'শীর্ষ মেশিন',
  clientAnalyticsNoData: 'এই সময়ে কোনো সম্পূর্ণ বুকিং নেই',
  operatorAnalyticsTitle: 'কাজের বিশ্লেষণ',
  operatorAnalyticsPresentDays: 'উপস্থিত দিন',
  operatorAnalyticsHalfDays: 'অর্ধ দিন',
  operatorAnalyticsHmr: 'মোট HMR',
  operatorAnalyticsJobs: 'সম্পন্ন কাজ',
  operatorAnalyticsIssues: 'রিপোর্ট করা সমস্যা',
  operatorAnalyticsAvgHmr: 'গড় HMR/দিন',
  operatorAnalyticsMonthlyTrend: 'মাসিক কাজের প্রবণতা',
  operatorAnalyticsIssueBreakdown: 'ধরন অনুযায়ী সমস্যা',
  operatorAnalyticsRecentJobs: 'সাম্প্রতিক কাজ',
  operatorAnalyticsNoData: 'এই সময়ে কাজের রেকর্ড নেই',
  adminServiceAlertsTitle: 'সেবা সতর্কতা',
  adminServiceAllOk: 'সব মেশিনের সেবা রেকর্ড আপ-টু-ডেট ✅',
  adminServiceNoRecord: 'কোনো রেকর্ড নেই',
  adminServiceColLastService: 'শেষ সেবা',
  adminServiceColNextDue: 'পরবর্তী দেয়',
  adminServiceColServiceStatus: 'সেবার অবস্থা',
  adminMachinesColMinHrs: 'ন্যূন. ঘণ্টা',
  adminMachinesColRateDay: 'হার/দিন',
  adminClientName: 'গ্রাহকের নাম',
  adminOwnerName: 'মালিকের নাম',
  adminPayoutWallet: 'পেআউট ওয়ালেট',
  adminFooterMachines: 'মেশিন',
  adminFooterClients: 'ক্লায়েন্ট',
  adminFooterOwners: 'মালিক',
  auditSeverityCritical: 'গুরুতর',
  auditSeverityHigh: 'উচ্চ',
  auditSeverityMedium: 'মধ্যম',
  auditSeverityNormal: 'সাধারণ',
  auditCopyEvent: 'ইভেন্ট কপি করুন',
  auditViewDetails: 'বিবরণ দেখুন',
  auditHideDetails: 'বিবরণ লুকান',
  auditCopyJson: 'JSON কপি করুন',
  auditNoLogs: 'কোনো অডিট লগ নেই',
  auditIntroBanner: 'লগইন, অ্যাডমিন কার্যক্রম এবং নিরাপত্তা ঘটনা। ফিল্টার লোড করা ফলাফলে প্রযোজ্য; পুরনো সারির জন্য আরও লোড করুন।',
  auditLoaded: 'লোড করা',
  auditMoreAvailable: 'আরও উপলব্ধ',
  auditEndOfList: 'তালিকার শেষ',
  auditFilterActive: 'ফিল্টার সক্রিয়',
  auditFiltersActive: 'ফিল্টার সক্রিয়',
  auditSeverityBreakdown: 'তীব্রতা বিভাজন (বর্তমান তালিকা)',
  auditPressSlash: 'অ্যাকশন ফিল্টারে ফোকাস করতে / চাপুন',
  auditFilters: 'ফিল্টার',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'সমস্ত ভূমিকা',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'মেটাডেটা JSON অনুসন্ধান',
  auditFilterFromPlaceholder: 'শুরুর তারিখ ও সময়',
  auditFilterToPlaceholder: 'শেষ তারিখ ও সময়',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'সময় অঞ্চল:',
  auditTimezoneSuffix: '(স্থানীয়)',
  auditHideCsvOptions: 'CSV কলাম বিকল্প লুকান',
  auditShowCsvOptions: 'CSV কলাম বিকল্প দেখান',
  auditCsvColCreatedAt: 'তৈরির সময়',
  auditCsvColAction: 'কার্যক্রম',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'মেটাডেটা',
  auditFooterLoaded: 'লোড করা',
  auditFooterLogs: 'অডিট লগ',
  auditFooterMoreAvailable: '(আরও উপলব্ধ)',
  auditFooterAllLoaded: '(সব লোড করা)',
  auditActor: 'অভিনেতা',
  auditEntity: 'সত্তা',
  auditEventLog: 'ইভেন্ট লগ',
  notificationCenter: 'বিজ্ঞপ্তি',
  notifChannelAll: 'সব',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ইমেইল',
  notifChannelPush: 'পুশ',
  notifChannelSms: 'SMS',
  notifStatusSent: 'পাঠানো হয়েছে',
  notifStatusFailed: 'ব্যর্থ',
  notifStatusPending: 'মুলতুবি',
  notifEmpty: 'এখনও কোনো বিজ্ঞপ্তি নেই',
  notifLoadMore: 'আরও লোড করুন',
  adminNotifLog: 'বিজ্ঞপ্তি লগ',
  adminNotifColUser: 'ব্যবহারকারী',
  adminNotifColRole: 'ভূমিকা',
  adminNotifNoData: 'এখনও কোনো বিজ্ঞপ্তি লগ হয়নি',
  etaOwnerApproval: 'মালিকের অনুমোদনের জন্য অপেক্ষা',
  etaWorkInProgress: 'আনুমানিক সমাপ্তি',
  etaPaymentDeadline: 'পেমেন্ট নিশ্চিতকরণের সময়সীমা',
  etaWorkCompleted: 'কাজ সম্পন্ন হয়েছে',
  etaDisputeReview: 'DE দল বিতর্ক পর্যালোচনা করছে',
  etaMinutesRemaining: '{n} মিনিট বাকি',
  etaHoursRemaining: '{n} ঘণ্টা বাকি',
  txRecharge: 'ওয়ালেট রিচার্জ',
  txBookingAdvance: 'বুকিং অগ্রিম',
  txBookingPayment: 'বুকিং পেমেন্ট',
  txSettlement: 'সেটেলমেন্ট',
  txRefund: 'রিফান্ড',
  txPenalty: 'জরিমানা',
  txCommission: 'কমিশন',
  tacTitle: "শর্তাবলী",
  tacPrivacy: "গোপনীয়তা নীতি",
  tacRefund: "রিফান্ড নীতি",
  tacCancellation: "বাতিলকরণ নীতি",
  tacServiceDelivery: "সেবা প্রদান নীতি",
  tacIntro: "বুকিংয়ের আগে আমাদের নীতি দেখুন",
  tacBannerTitle: "শর্তাবলী আপডেট উপলব্ধ",
  tacBannerOpen: "শর্তাবলী খুলুন",
  tacBannerAgree: "আমি পড়েছি এবং সম্মত",
  tacBannerLater: "পরে",
  clientPoliciesTitle: "ক্লায়েন্ট নীতি",
  machineGroupAvailable: "উপলব্ধ",
  machineGroupBusy: "ব্যস্ত",
  dewateringReferral: "ডিওয়াটারিং (পাম্প) সেবা দরকার? MachineOS শীঘ্রই পাম্প ঠিকাদার সেবা যোগ করবে। রেফারালের জন্য সাপোর্টে যোগাযোগ করুন।",
  noActiveWork: "এই মাসে কোনো সক্রিয় কাজ নেই",
  accountTab: "অ্যাকাউন্ট",
  recentActivity: "সাম্প্রতিক কার্যকলাপ",
  goodMorning: "শুভ সকাল",
  goodAfternoon: "শুভ দুপুর",
  goodEvening: "শুভ সন্ধ্যা",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
